var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "login-bg-main-section register-main-section width-full float-l",
      attrs: { id: "login-main-hr" }
    },
    [
      _vm.currentEnvironment
        ? _c(
            "div",
            { staticClass: "notification-block notification-block-top" },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-left-section float-l" },
        [
          _c("router-link", { attrs: { to: { path: "/" } } }, [
            _c("img", {
              attrs: {
                src: "/static/images/vvg-home-logo.png",
                alt: "Velocity Truck Center"
              }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "register-right-main-section width-full float-l" },
        [
          _c(
            "form",
            {
              staticClass: "cmxform",
              attrs: { id: "forgotPassword", name: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.emailVerify()
                }
              }
            },
            [
              _c("div", { staticClass: "register-form-main" }, [
                _c("h2", [_vm._v(" Forgot Password ")]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3"
                    },
                    [
                      _vm.isEmail == "undefined"
                        ? _c("label", { attrs: { for: "uname" } }, [
                            _vm._v("Dayforce Id / Email "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ])
                        : _vm.isEmail == true
                        ? _c("label", { attrs: { for: "uname" } }, [
                            _vm._v("Email "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ])
                        : _c("label", { attrs: { for: "uname" } }, [
                            _vm._v("Dayforce Id "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username"
                          }
                        ],
                        attrs: {
                          id: "username",
                          type: "text",
                          placeholder: "",
                          name: "uname"
                        },
                        domProps: { value: _vm.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.username))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3"
                    },
                    [
                      _c("font", { staticClass: "text-danger" }, [
                        _c("label", {
                          staticClass: "error text-danger",
                          attrs: { id: "errorMsg" }
                        }),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _c("label", {
                          staticClass: "success text-success",
                          attrs: { id: "successMsg" }
                        }),
                        _c("br")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(1)
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-primary alert-dismissible",
        attrs: { role: "alert", "aria-live": "polite", "aria-atomic": "true" }
      },
      [
        _c("div", { staticClass: "scroll-left" }, [
          _c("p", [_vm._v("This is Test Environment !")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "btm-login-section btm-register-section col-12 float-l" },
      [
        _c(
          "div",
          {
            staticClass:
              "btn-login-main float-l col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "button",
                {
                  staticClass: "hvr-sweep-to-right-red",
                  attrs: { id: "sendEmail" }
                },
                [_vm._v("Submit")]
              )
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f231e0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f231e0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = null
// module chunks = 